import ReportProblem from '../../../../components/report-problem';
import enhance from './report-problem';

export default enhance(ReportProblem);
